const GT = {
  countryConfig: {
    accountHolderDocNumber: {
      visible: true,
      label: "bankDetails.accountHolderDocNumber",
      placeholder: "bankDetails.documentCedulaPlaceholder",
      required: true,
    },
    accountTypeBankDetails: {
      label: "bankDetails.accountTypeBankDetails",
      visible: true,
      required: true,
    },
    IBAN: {
      visible: false,
      required: false,
    },
    bankName: {
      visible: false,
      required: false,
    },
    accountNumber: {
      label: "bankDetails.accountNumber",
      visible: true,
      required: true,
    },
    swift: {
      label: "bankDetails.swift",
      visible: true,
      required: true,
    },
    bankAddress: {
      visible: false,
      required: false,
    },
  },
};
export { GT };
